module.exports = __webpack_public_path__ + "img/14.991a4d6f.jpg";